import React from 'react'
import PropTypes from 'prop-types'

import styled, { css } from 'styled-components'

import MuiTypography from '@material-ui/core/Typography'

import { colorPropType } from 'app/utils'

import theme from 'app/theme'

const CsgTypography = styled(({ fontweight, fontsize, color, colorType, lineHeight, ...props }) => (
  <MuiTypography {...props} />
))`
  && {
    color: ${props => theme.palette[props.color][props.colorType]};

    ${props =>
      props.fontsize &&
      css`
        font-size: ${props.fontsize}px;
      `}

    ${props =>
      props.fontweight &&
      css`
        font-weight: ${props.fontweight};
      `}

    ${props =>
      props.lineHeight &&
      css`
        line-height: ${props.lineHeight};
      `};
  }
`

CsgTypography.defaultProps = {
  color: 'text',
  colorType: 'main'
}

CsgTypography.propTypes = {
  ...MuiTypography.propTypes,
  color: colorPropType,
  colorType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lineHeight: PropTypes.string,
  fontsize: PropTypes.number
}

export default CsgTypography
